import { cn } from '../../lib/utils';

type MessageProps = {
    type: 'error' | 'warning' | 'info';
    message?: string;
    className?: string;
    children?: React.ReactNode;
};

export const Message = ({ message, className, children, type }: MessageProps) => {
    return (
        <div className={cn('text-sm text-black', className)} aria-label={type}>
            {message || children}
        </div>
    );
};
